import {AnyAction, Dispatch} from "@reduxjs/toolkit";
import axios from "axios";
import {checkPaymentDoneUrl, previewStatusUrl} from "./url";
import {setAllowCheckPaymentDone, setPreviewDataFromBackend, setSavedProjectPaymentDone} from "../store/makerDataSlice";
import * as Sentry from "@sentry/react";
import {store} from "../store/store";
import SavedProjectData from "../Interfaces/SavedProjectData";

const getTimeout = {
    id: null,
};

export default async function checkPaymentDone(savedProjectData: SavedProjectData|null|undefined, dispatch: Dispatch<AnyAction>, i: number) {
    try {
        if (savedProjectData === null || typeof savedProjectData === 'undefined') {
            return;
        }
        const response = await axios.get(checkPaymentDoneUrl, {
            params: {
                id: savedProjectData.id,
                uid: savedProjectData.uid,
                vp: savedProjectData.vp,
                i: i
            }
        });
        if (response.data.result == 'ok') {
            if (response.data.id == savedProjectData.id &&
                response.data.uid == savedProjectData.uid &&
                response.data.vp == savedProjectData.vp) {
                if (response.data.isPaymentDone == true) {
                    dispatch(setSavedProjectPaymentDone(true));
                    dispatch(setAllowCheckPaymentDone(false));
                    if (getTimeout.id !== null) clearTimeout(getTimeout.id);
                    return;
                }
                if (i > 600) {
                    if (getTimeout.id !== null) clearTimeout(getTimeout.id);
                    return;
                }
                const makerData = store.getState().makerData;
                if (makerData.allowCheckPaymentDone) {
                    if (getTimeout.id !== null) clearTimeout(getTimeout.id);
                    // @ts-ignore
                    getTimeout.id = setTimeout(() => {
                        checkPaymentDone(savedProjectData, dispatch, i+1);
                    }, 1000);
                }
            }
        } else {
            Sentry.captureException(
                new Error('Failed to get check payment done.'),
                {
                    extra: {
                        url: checkPaymentDoneUrl,
                        response: response,
                        responseConfig: JSON.stringify(response?.config),
                        responseData: JSON.stringify(response?.data),
                        savedProjectData: savedProjectData
                    }
                }
            )
        }
    } catch (err) {
        Sentry.captureException(
            new Error('Failed to get check payment done. Error.'),
            {
                extra: {
                    url: checkPaymentDoneUrl,
                    savedProjectData: savedProjectData,
                    error: err,
                    responseConfig: axios.isAxiosError(err) ? JSON.stringify(err.response?.config) : '',
                    responseData: axios.isAxiosError(err) ? JSON.stringify(err.response?.data) : ''
                }
            }
        )
    }
}